import { useState } from 'react';
import useModal from 'hooks/UI/useModal';
import styled, { Box, useTheme } from '@xstyled/styled-components';
import RatingModal from '@/Modals/Rating';
import StarRating from '@/UI/Ratings/StarRating';
import Button from '@/UI/Button';
import { FlexBox } from '@/UI/Primitives/FlexBox';
import { useTranslation } from 'next-i18next';

const RatingsContainer = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 720px;
  margin-bottom: 5rem;

  p {
    font-weight: 600;
  }

  button {
    align-self: center;
  }

  @media (max-width: desktop) {
    padding: 0 1rem;
    margin-bottom: 5rem;
  }
`;

export default function Reviews({ product }) {
  const { t } = useTranslation();

  const theme = useTheme();
  const { isShown, toggle } = useModal();

  const reviews = product?.reviews?.items;
  const [reviewsShown, setReviewsShown] = useState(2);

  return (
    <>
      <RatingsContainer>
        <p>
          {t('review.comments')} ({reviews?.length})
        </p>

        {reviews?.length > 0 && (
          <Box pt={{ _: '1.5rem', desktop: '4rem' }} pb="3rem">
            {reviews?.slice(0, reviewsShown).map((review, i) => {
              return (
                <Box
                  key={i}
                  pt={{ _: i > 0 && '3rem', desktop: i > 0 && '6rem' }}
                >
                  <FlexBox
                    align="center"
                    justify="space-between"
                    pb={{ _: '1rem', desktop: '2rem' }}
                  >
                    <h5>{review.nickname}</h5>
                    <FlexBox as="span" spaceX="0.75rem">
                      <span>{t('review.review')}:</span>{' '}
                      <StarRating
                        rating={review.average_rating}
                        spaceX="0.25rem"
                        transform="translateY(5%)"
                      />
                    </FlexBox>
                  </FlexBox>
                  <Box as="p" lineHeight="1.75">
                    {review.text}
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}

        {reviews?.length > reviewsShown && reviewsShown !== reviews?.length && (
          <Button
            mb="2rem"
            hoverColor="gray-200"
            textDecoration="underline"
            onClick={() => setReviewsShown(reviewsShown + 2)}
          >
            {t('review.show_more')}
          </Button>
        )}

        <Button
          onClick={toggle}
          mt={reviews?.length === 0 && 24}
          alignSelf={reviews?.length === 0 && 'flex-start'}
          p="0.5rem 3rem"
          color="teal-100"
          hoverColor="teal-300"
          border={`1px solid ${theme.colors['teal-100']}`}
          hoverBorder={`1px solid ${theme.colors['teal-300']}`}
        >
          {t('review.add_comment')}
        </Button>
      </RatingsContainer>
      <RatingModal product={product} isShown={isShown} toggle={toggle} />
    </>
  );
}
